import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Acceso7Rifas from './Acceso7Rifas';
import ErrorBoundary from './ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <Routes>
          <Route path="/" element={<Acceso7Rifas />} />
          <Route path="/todas-las-rifas" element={<Acceso7Rifas />} />
          <Route path="/rifa/:id" element={<Acceso7Rifas />} />
          <Route path="/pago/:id" element={<Acceso7Rifas />} />
          <Route path="/transferencia/:pagoId" element={<Acceso7Rifas />} />
          <Route path="/admin" element={<Acceso7Rifas />} />
          <Route path="/login" element={<Acceso7Rifas />} />
          <Route path="/registro" element={<Acceso7Rifas />} />
          <Route path="/crear-rifa" element={<Acceso7Rifas />} />
          <Route path="*" element={<Acceso7Rifas />} />
        </Routes>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
